import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import React from "react";
var CurriculumBoundaryReferences = function CurriculumBoundaryReferences(_ref) {
  var id = _ref.id,
    references = _ref.references,
    extraTexts = _ref.extraTexts;
  return /*#__PURE__*/React.createElement("div", {
    className: "alert alert-light p-2 border-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion curriculum-references",
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion-item border-none bg-transparent"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion-header",
    id: "".concat(id, "-header")
  }, /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "me-2",
    icon: faInfoCircle
  }), extraTexts, ". \xA0", /*#__PURE__*/React.createElement("span", {
    className: "p-0 shadow-none display-inline cursor-pointer no-icon-accordion-button text-decoration-underline",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#".concat(id, "-collapsable"),
    "aria-expanded": "true",
    "aria-controls": "".concat(id, "-collapsable")
  }, "View references"))), /*#__PURE__*/React.createElement("div", {
    id: "".concat(id, "-collapsable"),
    className: "accordion-collapse collapse",
    "aria-labelledby": "".concat(id, "-header"),
    "data-bs-parent": "#accordionExample"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion-body"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "list-group list-group-flush rounded"
  }, references.map(function (reference, index) {
    return /*#__PURE__*/React.createElement("li", {
      className: "list-group-item p-3 p-sm-4"
    }, /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("strong", null, "Page ", reference.page, ":"), " ", reference.text));
  })))))));
};
CurriculumBoundaryReferences.defaultProps = {
  references: [],
  extraTexts: '',
  id: 'referencesAccordion'
};
export default CurriculumBoundaryReferences;